import { ModuleConfig } from "../module.types";
import { businessAdminRoutes } from "./business-admin.routes";

export const businessAdminModule: ModuleConfig = {
  name: "business-admin",
  routes: businessAdminRoutes,
  services: {},
};
